import { Box, Button, CircularProgress, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';

interface EmailVerificationBannerProps {
  onResend: () => void;
  isLoading?: boolean;
}

const EmailVerificationBanner: React.FC<EmailVerificationBannerProps> = ({ onResend, isLoading }) => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 48,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        borderRadius: 0,
        backgroundColor: '#fff8e1',
        borderBottom: '1px solid #ffecb3',
        py: 1.5,
        px: 4,
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}>
        {/* Centered content */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, textAlign: 'center' }}>
          <Typography variant="body2">
            <strong>Your email address is not verified.</strong> If your verification link has expired, click{' '}
            <strong>Resend Email</strong> to receive a new one.
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              variant="text"
              onClick={onResend}
              disabled={isLoading}
              sx={{
                fontWeight: 500,
                color: isLoading ? '#bdbdbd' : '#ff6f00',
                textDecoration: 'underline',
                textTransform: 'none',
                minWidth: 'auto',
                padding: 0,
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: isLoading ? '#bdbdbd' : '#e65100',
                  textDecoration: 'underline',
                },
                '&.Mui-disabled': {
                  color: '#bdbdbd',
                },
              }}>
              Resend Email
            </Button>
            {isLoading && (
              <CircularProgress
                size={16}
                sx={{
                  color: '#ff6f00',
                  opacity: 0.8,
                }}
              />
            )}
          </Box>
        </Box>
        {/* Right side: close button */}
        <IconButton
          size="small"
          onClick={() => setVisible(false)}
          sx={{
            position: 'absolute',
            right: 0,
          }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default EmailVerificationBanner;
